import { useEffect } from "react";
import { createContext, useContext, useState } from "react";
import { useLocation } from "react-router-dom";

const AppContext=createContext();

const AppProvider=({children})=>{
    const [opens,setOpens]=useState(false)
const [openSide,setOpenSide]=useState(true);
const [isOpenModal,setOpenModal]=useState(false);
const [isOpenModal2,setOpenModal2]=useState(false);
const [isDeleteModalOpen,setISdeleteModalOpen]=useState(false)
const [isModalWarnOPen,setIsModalWarnOpen]=useState(false)
const [isStatusOpen,setStatusOpen]=useState(sessionStorage.getItem('status')=='close'?false:true)
const [isModalTimeOpen,setIsModalTimeOpen]=useState(false)
const [loading,setloading]=useState(false)
const [isModalCommentOpen,setIsModalCommentOpen]=useState(false)
const [searchShow,setSearchShow]=useState(false)
const [isModalEditCommentOpen,setIsModalEditCommentOpen]=useState(false)
const [isModalSensorCommentOpen,setIsModalSensorCommentOpen]=useState(false)
const [isModalEditSensCommentOpen,setIsModalEditSensCommentOpen]=useState(false)
const [isAllTimeOpen,setIsAllTimeOPen]=useState(false)
function ToGG (){
    const Nav=document.querySelector('.navIcon4');
    const Side=document.querySelector('.SidebarCon');
    const ChilfrenCon=document.querySelector('.ChildrenCon');
    setOpenSide(!openSide)
    



    if(openSide){

        Nav.classList.add('open');
        ChilfrenCon.classList.add('ChildrenConAdd')
         
        Side.classList.add('openSide');

    }else{

        Nav.classList.remove('open');
        ChilfrenCon.classList.remove('ChildrenConAdd')

        Side.classList.remove('openSide');

    }
    }
const openTime=()=>{
    setIsAllTimeOPen(!isAllTimeOpen);
}
const closeTime=(e)=>{
    if(e?.target){
    
    const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    const target=e?.target.classList.contains('modal-overlay')
    console.log(t2)
    if(target||t2){
        setIsAllTimeOPen(false);
    }
    }
    
}
const openSearch=()=>{
    setSearchShow(true);
}
const closeSearch=(e)=>{
    if(e?.target){
    
    const target=e?.target.classList.contains('searchResultCon')
    
    if(!target){
        setSearchShow(false);
    }
    }
    
}
const openD=()=>{
    setOpens(!opens);
}
const closeD=(e)=>{
    if(e?.target){
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setOpens(false);
    }
    }
    
}
const openStatus=()=>{
    setStatusOpen(!isStatusOpen);
}
const closeStatus=(e)=>{
    if(e?.target){
        sessionStorage.setItem('status','close')
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setStatusOpen(false);
    }
    }
    
}
const openModallEditSensorComment=()=>{
    setIsModalEditSensCommentOpen(!isModalEditSensCommentOpen);
}
const closeModallEditSensorComment=(e)=>{
    if(e?.target){
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setIsModalEditSensCommentOpen(false);
    }
    }
    
}

const openModallSensorComment=()=>{
    setIsModalSensorCommentOpen(!isModalSensorCommentOpen);
}
const closeModallSensorComment=(e)=>{
    if(e?.target){
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setIsModalSensorCommentOpen(false);
    }
    }
    
}
const openModalls=()=>{
    setOpenModal(!isOpenModal);
}
const closeModalls=(e)=>{
    if(e?.target){
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setOpenModal(false);
    }
    }
    
}
const openModalls2=()=>{
    setOpenModal2(!isOpenModal2);
}
const closeModalls2=(e)=>{
    if(e?.target){
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setOpenModal2(false);
    }
    }
    
}

const openDeleteModal=()=>{
    setISdeleteModalOpen(!isDeleteModalOpen)
}
const closedeleteModal=(e)=>{
   if(e?.target){
    const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setISdeleteModalOpen(!isDeleteModalOpen);
    }
   }
}

const openWarn=()=>{
    setIsModalWarnOpen(!isModalWarnOPen)
}
const closeWarn=(e)=>{
    if(e?.target){
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
     
     const target=e?.target.classList.contains('modal-overlay')
     
     if(target||t2){
        setIsModalWarnOpen(false)     }
    }
 }
const openModallTime=()=>{
    setIsModalTimeOpen(!isModalTimeOpen);
}
const closeModallTime=(e)=>{
    if(e?.target){
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setIsModalTimeOpen(false);
    }
    }
    
}
const openModallComment=()=>{
    setIsModalCommentOpen(!isModalCommentOpen);
}
const closeModallComment=(e)=>{
    if(e?.target){
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setIsModalCommentOpen(false);
    }
    }
    
}
const openEditModallComment=()=>{
    setIsModalEditCommentOpen(!isModalEditCommentOpen);
}
const closeEditModallComment=(e)=>{
    if(e?.target){
        const t2=e?.target.classList.contains('closee')|| e.target.parentNode.classList.contains('closee')
    
    const target=e?.target.classList.contains('modal-overlay')
    
    if(target||t2){
        setIsModalEditCommentOpen(false);
    }
    }
    
}



    return <>
    <AppContext.Provider value={{
        openSide,setOpenSide,openModalls,closeModalls,isOpenModal,openDeleteModal,closedeleteModal,isDeleteModalOpen,openModalls2,closeModalls2,isOpenModal2,closeWarn,isModalWarnOPen,openModallTime,closeModallTime,isModalTimeOpen,openModallComment,closeModallComment,isModalCommentOpen,openEditModallComment,closeEditModallComment,isModalEditCommentOpen,isModalSensorCommentOpen,openModallSensorComment,closeModallSensorComment,openModallEditSensorComment,closeModallEditSensorComment,isModalEditSensCommentOpen,loading,setloading,openD,closeD,opens,isAllTimeOpen,openTime,closeTime,openWarn,ToGG,openSearch,closeSearch,searchShow,openStatus,closeStatus,isStatusOpen
    }}>
        {children}
    </AppContext.Provider>
    </>
}
export const useGlobalContext = () => {
    return useContext(AppContext);
  };
  
  export { AppContext, AppProvider};